import Bridge from '@/customer-portal/overview/entities/bridge'

export default class BridgeResponse {
  public items: Bridge[]
}
